import { Component, Inject, OnInit } from "@angular/core";
import { ApplicationComponent } from "../application/application.component";
import { ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-pop-up-application",
  templateUrl: "./pop-up-application.component.html",
  styleUrls: ["./pop-up-application.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PopUpApplicationComponent implements OnInit {
  applicationData: any;

  constructor(
    public dialogRef: MatDialogRef<ApplicationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.applicationData = data;
  }

  ngOnInit() {
    console.log("Value From application page: ", this.applicationData);
  }
  onContinue() {
    this.dialogRef.close("continue");
  }
}
